'use client';

import React__default from 'react';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';
import WarningIcon from '../Images/Warning/index.js';
import { WarninglWrapper, Container, WarningAlert } from './styles.css.js';

var PopupWarning = function (props) {
    var _a = props.isShow, isShow = _a === void 0 ? false : _a, _b = props.langCode, langCode = _b === void 0 ? ELanguage.VI : _b, _c = props.title, title = _c === void 0 ? '' : _c, _d = props.primaryText, primaryText = _d === void 0 ? '' : _d, _e = props.secondaryText, secondaryText = _e === void 0 ? '' : _e, children = props.children, warningTxt = props.warningTxt, onClose = props.onClose, onAccept = props.onAccept;
    var t = function (text) {
        var _a;
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var onClickClose = function () {
        onClose && onClose();
    };
    var onClickAccept = function () {
        onAccept && onAccept();
    };
    return (React__default.createElement(WarninglWrapper, { isShow: isShow, lang: langCode, onClose: onClickClose, onClickOutside: onClickClose, onClickPrimary: onClickAccept, styleOption: {
            size: 'sm'
        }, text: {
            header: title !== null && title !== void 0 ? title : ' ',
            primaryBtn: primaryText || t('Continue'),
            secondaryBtn: secondaryText || t('Cancel')
        } },
        React__default.createElement(Container, null,
            children,
            warningTxt ? (React__default.createElement(WarningAlert, null,
                React__default.createElement(WarningIcon, null),
                warningTxt)) : (''))));
};

export { PopupWarning as default };
//# sourceMappingURL=index.js.map
